<template>
  <DBox :id="'cmp-settings-custom-texts-template-editor'" @add_click="onAddNewTemplate">
    <div class="screenshot">
      <img :src="`./static/images/${template_key}.png`" :alt="template_key" />
    </div>
    <div class="template-list">
      <div class="template-item" v-for="templ of templates" :key="templ.template_id">
        <div class="form-group">
          <div class="form-row">
            <TextField
              :id="'description'"
              :ref="`${templ.template_id}_description`"
              v-bind="textFieldConfig"
              :value="templ.description"
              :placeholder="$t('descriptions')"
              @valuechanged="(name, value) => onTemplateValueChange(name, value, templ)"
            />
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                @click="e => onDeleteTemplate(templ)"
                class="dt-icon v5 s1"
                :alt="$t('delete_template')"
                :title="$t('delete_template')"
              />
            </div>
          </div>
          <TextField
            :id="'subject'"
            v-bind="textFieldConfig"
            :value="templ.subject"
            :placeholder="$t('email_subject')"
            @valuechanged="(name, value) => onTemplateValueChange(name, value, templ)"
          />
          <TextField
            :id="'template_text'"
            v-bind="textFieldConfig"
            :value="templ.template_text"
            :placeholder="$t('body_text')"
            textarea
            :height="500"
            @valuechanged="(name, value) => onTemplateValueChange(name, value, templ)"
          />
          <div class="available-datapoints">
            <b>{{$t('available_datapoints')}}</b>
            <div class="datapoints">{{datapoints}}</div>
          </div>
        </div>
      </div>
    </div>
  </DBox>
</template>


<script>
import DBox from "@dtplugins/dbox/dbox";

import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { createTextFieldConfig, EventHooks } from "../../../../plugins/text-field";
import { capitalizeFirst } from '../../../../utility';

export default {
  components: {
    DBox
  },
  props: ["custom_textsSettingsData", "template_key"],
  data: function() {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur
      }),
      datapoints_dict: {
        offer_mail_to_artist: `[% start_date %], [% booking_location_name %], [% city %], [% country %], [% first_offer_notes %], [% artist %], [% artist_stage %] [% performance_type %], [% event_name %], [% notes_ical %], [% line_up %], [% venue_name %], [% venue_address %], [% venue_city %], [% venue_postalcode %], [% venue_country %], [% venue_phone %], [% venue_email %], [% venue_url %], [% venue_capacity %], [% promoter_company_name %], [% promoter_representative %], [% promoter_address %], [% promoter_city %], [% promoter_postalcode %], [% promoter_state %], [% promoter_country %], [% promoter_phone %], [% promoter_mobile %], [% promoter_email %], [% promoter_vat_id %], [% promoter_url %], [% promoter_language %]`,
        request_form_mail: `[% request_link %]`,
        promoter_questionnaire_mail: `[% start_date %], [% booking_location_name %], [% city %], [% country %], [% venue_url %], [% venue_capacity %], [% artists %], [% questionnaire_link %]`,
        booking_document_and_files:`[% start_date %], [% booking_location_name %], [% city %], [% country %], [% venue_url %], [% venue_capacity %], [% artists %], [% documents %], [% invoices %], [% files %]`
      }
    };
  },
  watch: {
    custom_textsSettingsData: {
      immediate: true,
      handler: function(to, from) {
        if (to?.new_template_id) {
          this.$nextTick(() => {
            console.log(this.$refs[`${to.new_template_id}_description`]);
            this.$refs[`${to.new_template_id}_description`]?.[0]?.$el?.querySelector("input")?.focus();
          });
        }
      }
    }
  },
  computed: {
    templates: function() {
      return this.custom_textsSettingsData?.[this.template_key]?.templates || [];
    },
    datapoints: function() {
      return this.datapoints_dict[this.template_key];
    }
  },
  methods: {
    onAddNewTemplate: function() {
      const lastTemplate = this.templates[this.templates.length - 1];
      let description, template_text;

      if (lastTemplate) {
        description = `${lastTemplate.description} Copy`;
        template_text = lastTemplate.template_text;
      } else {
        description = `New ${capitalizeFirst(this.template_key)}`;
        template_text = this.datapoints;
      }

      this.$emit("add_new", {
        template_key: this.template_key,
        description,
        template_text,
      });
    },
    onTemplateValueChange: function(name, value, item) {
      console.log({ item, name, value });
      this.$emit("updated", {
        item,
        name,
        value,
        template_key: this.template_key
      });
    },
    onDeleteTemplate: function(template) {
      this.$emit("deleted", {
        template_key: this.template_key,
        template_id: template.template_id,
        description: template.description
      });
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-custom-texts-template-editor {
  display: flex;
  .screenshot {
    flex: 1;

    img {
      padding: 5px;
      width: 100%;
    }
  }
  .template-list {
    flex: 1;
    min-height: 700px;
    max-height: 700px;
    overflow: auto;

    .template-item {
      padding: 10px 0px;
      border-bottom: 1px solid var(--sprt-8);
      border-left: 1px solid var(--sprt-8);

      .form-group {
        .form-row {
          display: flex;
          .dt-input-box--container {
            flex: 1;
          }
          .dt-icon-container {
            margin-top: auto;
            margin-bottom: auto;
          }
        }
        .available-datapoints {
          padding: 10px 15px;
          background: var(--bc-3);

          .datapoints {
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>